import { render, staticRenderFns } from "./farmView.vue?vue&type=template&id=25c21dd6&scoped=true"
import script from "./farmView.vue?vue&type=script&lang=js"
export * from "./farmView.vue?vue&type=script&lang=js"
import style0 from "./farmView.vue?vue&type=style&index=0&id=25c21dd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c21dd6",
  null
  
)

export default component.exports